import axios from "axios";
import { IP_REGISTRY_KEY } from "../../config/constants";
import { commanValidation } from "./ValidationFunction";
import { AxiosResponse } from "axios";

type ModalIndex = 0 | 1 | 2 | 3 | 4 | 5 | 6;

export const handleChangeModalDisplay = (
  i: ModalIndex,
  setPageDisplayIndex: (index: any | null) => void,
  checkEmail: () => void
): void => {
  if (i === 0) {
    setPageDisplayIndex(1);
  } else if (i === 1) {
    checkEmail();
  } else if (i === 2) {
    setPageDisplayIndex(3);
  } else if (i === 3) {
    setPageDisplayIndex(4);
  } else if (i === 4) {
    setPageDisplayIndex(6);
  } else if (i === 5) {
    setPageDisplayIndex(6);
  } else {
    setPageDisplayIndex(null);
  }
};

export const getData = async (
  setIpAddressName: (value: any) => void,
  setCountryName: (value: any) => void,
  setFormValue: (value: any) => void,
  formValue: any,
  searchParams: URLSearchParams
): Promise<void> => {
  const res: AxiosResponse<any> = await axios.get(`https://api.ipregistry.co/?key=${IP_REGISTRY_KEY}`);
  setIpAddressName(res.data.ip);
  setCountryName(res.data.location.country.name);

  if (res) {
    const sid = searchParams.get("sid") ? searchParams.get("sid") : "";
    const clickid = searchParams.get("clickid") ? searchParams.get("clickid") : "";
    const geo = searchParams.get("geo") ? searchParams.get("geo") : "";
    const referralBy = searchParams.get("referralBy") ? searchParams.get("referralBy") : "";
    setFormValue({
      ...formValue,
      language: res.data.location.language.name,
      timeZone: res.data.time_zone.id,
      country: res.data.location.country.name,
      state: res.data.location.region.name,
      currentUrl: window.location.href,
      referalId: referralBy,
      sid,
      clickid,
      geo,
    });
  }
};

export function handleSendOtp(
  e: React.FormEvent,
  formValue: any,
  setFormValue: (value: any) => void,
  con2: boolean,
  t: (key: string) => string,
  SendOtp: { mutate: () => void }
): void {
  e.preventDefault();
  const emailValid = commanValidation(formValue, setFormValue, con2, t);
  if (emailValid && formValue.errors.email === "" && formValue.email !== "") {
    SendOtp.mutate();
  }
}

export function handleReSendOtp(
  e: React.FormEvent,
  formValue: any,
  setFormValue: (value: any) => void,
  con2: boolean,
  t: (key: string) => string,
  ReSendOtp: { mutate: () => void }
): void {
  e.preventDefault();
  const emailValid = commanValidation(formValue, setFormValue, con2, t);
  if (emailValid && formValue.errors.email === "" && formValue.email !== "") {
    ReSendOtp.mutate();
  }
}

export function handleVarifyOtp(
  e: React.FormEvent,
  formValue: any,
  setFormValue: (value: any) => void,
  con2: boolean,
  t: (key: string) => string,
  VerifyOtp: { mutate: () => void }
): void {
  e.preventDefault();
  const emailvalid = commanValidation(formValue, setFormValue, con2, t);
  if (emailvalid && formValue.errors.email === "" && formValue.email !== "") {
    VerifyOtp.mutate();
  }
}

export const handleYesChange = (
  setYesSelected: (value: boolean) => void,
  setNoSelected: (value: boolean) => void,
  setFormValue: (value: any) => void,
  referralBy1: string
): void => {
  setYesSelected(true);
  setNoSelected(false);
  setFormValue((prevState: any) => ({
    ...prevState,
    referalId: referralBy1,
  }));
};

export const handleNoChange = (
  setYesSelected: (value: boolean) => void,
  setNoSelected: (value: boolean) => void,
  setFormValue: (value: any) => void
): void => {
  setYesSelected(false);
  setNoSelected(true);
  setFormValue((prevState: any) => ({
    ...prevState,
    referalId: "",
  }));
};